<template>
  <div class="ai-teach-app-container">
    <div class="container-top">
      <div class="main-title">2025年海南大学“AI赋能”课堂教学展示大赛-优秀作品展</div>
      <div class="right-btn">
        <div class="btn-left">
          <CircleButton type="pre" />
        </div>
        <div class="btn-right">
          <CircleButton type="next" />
        </div>
      </div>
    </div>
    <div class="swiper-box" v-if="appList.length > 0">
      <Swiper
        :watchSlidesProgress="true"
        slidesPerView="3.15"
        :loop="true"
        :observer="true"
        :observeParents="true"
        :observeSlideChildren="true"
        :autoplay="{ delay: 5000, disableOnInteraction: false }"
        :modules="modules"
        class="swiper-content"
        :navigation="{
          nextEl: '.btn-right',
          prevEl: '.btn-left',
        }"
      >
        <SwiperSlide
          class="swiper-slide"
          v-for="(item, index) in appList"
          :key="index"
          @click="handleDetail(index)"
        >
          <div class="app-card">
            <div class="app-card-img">
              <img :src="item.cover_url"/> 
            </div>
            <div class="app-card-title">{{ item.name }}</div>
            <div class="app-card-sub-title">{{ item.teacher }}<span>{{ item.college }}</span>
            </div>
            <div class="app-btn">
              <img src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/ea73f840e11f4b03ad3cd87395fa80be.png"/>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    <div v-else>
      <div class="no-data">
        <Empty />
      </div>
    </div>
    <VideoDialog v-model:show="showVideoDialog" :videoList="appList" v-model:activeIndex="activeIndex" />
  </div>
</template>
<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js'
import SwiperCore, { Navigation, A11y, Autoplay, Pagination, EffectCoverflow } from 'swiper'
SwiperCore.use([Navigation, A11y, Autoplay, Pagination, EffectCoverflow])
import 'swiper/swiper-bundle.min.css'
import { Empty } from 'zhs-components'
import VideoDialog from '@/pages/components/FilePreview/VideoDialog.vue'
import CircleButton from './CircleButton.vue'
import { inject, onMounted, reactive, ref } from 'vue'

const modules = [Navigation, A11y, Autoplay, Pagination, EffectCoverflow]

const $http = inject('$http')

const appList = ref([])

const activeIndex = ref(0)

const showVideoDialog = ref(false);

const videoInfo = reactive({
  title: '111',
  url: 'https://alivideo.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/3682e2070414424fa66a110948ae437b.mp4',
});
const getAppList = async () => {
  const data = await $http.getExcellentWorksList();
  appList.value = data;
  // appList.value.forEach(item => {
  //   item.jump_url = 'https://alivideo.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/3682e2070414424fa66a110948ae437b.mp4'
  // })
};

const handleDetail = index => {
  window.open(appList.value[index].jump_url)
  // activeIndex.value = index
  // showVideoDialog.value = true
}

onMounted(() => {
  getAppList()
})
</script>

<style lang="scss" scoped>
.ai-teach-app-container {
  width: 1240px;
  padding-top: 40px;
  position: relative;
  .container-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
    .main-title {
      color: #1C212A;
      font-family: "Alibaba PuHuiTi";
      font-size: 32px;
      font-weight: 700;
      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 24px;
        background-color: #194189;
        margin-right: 8px;
      }
    }
    .btn {
      width: 64px;
      height: 64px;
    }
    .right-btn {
      display: flex;
      cursor: pointer;
      .btn-left {
        
      }
      .btn-right {
        margin-left: 28px;
      }
    }
  }
  .swiper-box {
    position: relative;
    margin-top: 62px;
    .swiper-content {
      width: 100%;
      margin: auto;
    }
    .swiper-slide {
      .app-card {
        width: 370px;
        height: 320px;
        border-radius: 12px;
        background-color: #fff;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
        &:hover {
          .app-card-title {
            color: #1546F2;
          }
          .app-btn {
            display: block;
          }
        }
        .app-card-img {
          width: 100%;
          height: 220px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 12px;
          }
        }
        .app-card-title {
          font-family: "PingFang SC";
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          margin-top: 12px;
        }
        .app-card-sub-title {
          color: #1C212A;
          font-family: "PingFang SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          margin-top: 8px;
          span {
            margin-left: 8px;
          }
        }
        .app-btn {
          position: absolute;
          bottom: 60px;
          right: 20px;
          width: 72px;
          height: 72px;
          display: none;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
